// /app/frontend/src/components/frugal-v2/components/emails/emailConstants.js
// Constants and helpers for email modals (20 lines)

export const DEFAULT_CATEGORIES = [
  'Alimentacion', 'Transporte/Mantenimiento', 'Salud', 'Servicios', 
  'Entretenimiento', 'Suscripciones', 'Restaurante/Bar', 'Caprichos', 'Otros'
];

export const findSuggestedExpenses = (recurringExpenses, merchant) => {
  if (!merchant) return [];
  const merchantLower = merchant.toLowerCase();
  return recurringExpenses.filter(exp => 
    exp.name?.toLowerCase().includes(merchantLower) ||
    merchantLower.includes(exp.name?.toLowerCase() || '')
  );
};

export const getCategories = (budgetCategories) => {
  if (budgetCategories?.length > 0) {
    return budgetCategories.map(c => c.category || c.name || c);
  }
  return DEFAULT_CATEGORIES;
};
